unit uConstants;
//***
//*** This material is a confidential Trade Secret belonging to David P. Schwartz and VBB Media ***
//
// FILE: uConstants.pas
// VERSION: 1.2
// CREATED: 6/16/26

interface

const
  JSON_SERVICE_URL        = 'https://promptlockers.com/mvp3/locker_data_service.php';

  LOCKER_STORAGE_API_BASE_URL  = 'https://promptlockers.com/mvp3/';

  LOCKER_STORAGE_API_KEY  = 'epaPTS5BnWpvRnKpdzMH';  // same for all (for now)
  LOCKER_PROMPTS_API_URL  = LOCKER_STORAGE_API_BASE_URL+'locker_prompts_api.php';
  LOCKER_METADATA_API_URL = LOCKER_STORAGE_API_BASE_URL+'locker_metadata_api.php';
  CATALOG_READER_URL      = LOCKER_STORAGE_API_BASE_URL+'catalog_reader.php';
  OR_MODELS_SERVICE_URL   = LOCKER_STORAGE_API_BASE_URL+'openrouter_models.php';
  WGWA_API_URL            = LOCKER_STORAGE_API_BASE_URL+'wgwa_api.php';

  LOCKER_EXECUTE_API_URL = LOCKER_STORAGE_API_BASE_URL+'locker_execute_api.php';

  LOCKER_STATE_STORAGE_KEY = 'abracadabra';

  PROMPT_CONVERTER_LOCKER_ID = 'prompt-converter-001';

  // used in WGWA
  SUPADATA_URL = 'https://api.supadata.ai/v1/youtube/transcript';

  SUPADATA_KEY = 'sd_0bd4e23e6af2bf522f8b484757583ee7';   // needs to move into server side

implementation

end.
